import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Badge } from '@/components/ui/Badge';
import type { BlogPost } from '@/types/blog';

export const PostCard = ({ post }: { post: BlogPost }) => (
  <article className="post-card">
    <div className="post-card__header">
      <Badge>{post.category}</Badge>
    </div>

    <h2 className="post-card__title">
      <Link to={`/posts/${post.slug}`}>{post.title}</Link>
    </h2>

    <p className="post-card__description">{post.description}</p>

    <div className="post-card__footer">
      <div className="post-card__meta">
        <span>{post.date ? format(new Date(post.date), 'dd MMM yyyy') : ''}</span>
        <span>{post.readingTime}</span>
      </div>
      <div className="post-card__tags">
        {(post.tags ?? []).map((tag) => (
          <Link key={tag} to={`/tags/${tag.toLowerCase()}`}>
            #{tag}
          </Link>
        ))}
      </div>
    </div>
  </article>
);
